import React, { ReactNode } from 'react';
import { ArchitecturalForm } from './ArchitecturalForm';
interface CtaBandProps {
  title: string;
  text: string;
  children: ReactNode;
  tone?: 'aubergine' | 'plum';
}
export function CtaBand({
  title,
  text,
  children,
  tone = 'plum'
}: CtaBandProps) {
  return <section className={`on-dark overflow-hidden ${tone === 'plum' ? 'bg-plum' : 'bg-aubergine'} text-porcelain`} data-id="element-468" data-mp="102512p4zr2xb">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-6 py-20 lg:grid-cols-12 lg:px-10 lg:py-24" data-id="element-469" data-mp="v3abn4ciqg48">
        <div className="lg:col-span-8" data-id="element-470" data-mp="r045dwpeooxr">
          <h2 className="text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-471" data-mp="r39xlktc06xp">{title}</h2>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-porcelain/75" data-id="element-472" data-mp="h2zgvq838hds">{text}</p>
          <div className="mt-10 flex flex-wrap gap-4" data-id="element-473" data-mp="h5c7errww02g">{children}</div>
        </div>
        <div className="hidden lg:col-span-4 lg:block" data-id="element-474" data-mp="2gfbyxcftor8r">
          <ArchitecturalForm variant="frame" tone="dark" className="mx-auto max-w-xs" data-id="element-475" data-mp="2bgr0nik4shmy" />
        </div>
      </div>
    </section>;
}